import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/auth.css";

const AuthLayout = ({ children }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showDetails = !isMobile || expanded;

  return (
    <div className="auth-wrapper">
      {/* LEFT PANEL */}
      <div className="auth-left">

        {/* Logo + Title — always visible */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: isMobile ? 8 : 16 }}>
          <img
            src="/logo192.png"
            alt="FDS Logo"
            style={{ width: isMobile ? 36 : 48, height: isMobile ? 36 : 48, borderRadius: 10, objectFit: "contain" }}
          />
          <div>
            <h1 style={{ margin: 0, fontSize: isMobile ? 20 : 28 }}>Fraud Detect System</h1>
            <p style={{ margin: 0, fontSize: 12, opacity: 0.75 }}>For SelfDrive Car Rental Owners</p>
          </div>
        </div>

        {/* Mobile toggle button */}
        {isMobile && (
          <button
            onClick={() => setExpanded(v => !v)}
            style={{
              background: "rgba(255,255,255,0.2)",
              border: "1px solid rgba(255,255,255,0.4)",
              color: "#fff",
              borderRadius: 20,
              padding: "5px 16px",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              marginBottom: 4,
            }}
          >
            {expanded ? "▲ View Less" : "▼ View More"}
          </button>
        )}

        {/* Mission + Vision — collapsible on mobile */}
        {showDetails && (
          <>
            <div style={{ marginTop: 16, marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, opacity: 0.7, marginBottom: 6, textTransform: "uppercase" }}>
                Our Mission
              </div>
              <p style={{ fontSize: 13, opacity: 0.9, lineHeight: 1.8, margin: 0 }}>
                To protect self-drive car rental owners across India from fraudulent customers through a centralized, verified fraud reporting network.
              </p>
            </div>

            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, opacity: 0.7, marginBottom: 6, textTransform: "uppercase" }}>
                Our Vision
              </div>
              <p style={{ fontSize: 13, opacity: 0.9, lineHeight: 1.8, margin: 0 }}>
                India's most trusted fraud prevention network for vehicle rentals — empowering every rental owner to run their business with confidence and security.
              </p>
            </div>

            <button className="read-more" onClick={() => navigate("/about")}>
              Read More
            </button>
          </>
        )}

        {/* Company footer — always visible */}
        <div style={{ marginTop: "auto", paddingTop: 20, fontSize: 11, opacity: 0.6, lineHeight: 1.8 }}>
          <div style={{ fontWeight: 700, marginBottom: 2 }}>Uvars OPC Private Limited</div>
          <div>&copy; {new Date().getFullYear()} All rights reserved.</div>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className="auth-right">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
